export default "__VITE_ASSET__d445ffb2__"